import type { EnrichedB2BWaveProduct } from '@flote/types/product';
import type { DeliveryDestination } from '@flote/types/delivery';
import type { BaseModalPropsMap } from '@flote/app-core/modal';
import type { BankAccountFormData } from '../../pages/checkout/components/BankAccountForm';

export enum ModalType {
  AUTH_MODAL = 'AUTH_MODAL',
  REGISTRATION_MODAL = 'REGISTRATION_MODAL',
  PRODUCT_DETAIL = 'PRODUCT_DETAIL',
  ADDRESS_MODAL = 'ADDRESS_MODAL',
  CART_DRAWER = 'CART_DRAWER',
  BANK_ACCOUNT_FORM_MODAL = 'BANK_ACCOUNT_FORM_MODAL',
}

export interface ModalPropsMap extends BaseModalPropsMap {
  [ModalType.AUTH_MODAL]: Record<string, unknown>;
  [ModalType.REGISTRATION_MODAL]: {
    userEmail?: string;
  };
  [ModalType.PRODUCT_DETAIL]: {
    product: EnrichedB2BWaveProduct;
  };
  [ModalType.ADDRESS_MODAL]: {
    onSave: (destination: DeliveryDestination) => void;
  };
  [ModalType.CART_DRAWER]: Record<string, unknown>;
  [ModalType.BANK_ACCOUNT_FORM_MODAL]: {
    onSubmit: (data: BankAccountFormData) => Promise<void>;
    isProcessing?: boolean;
  };
}
